/**
 * @file
 * Makes header sticky.
 * @link: https://github.com/m-danish-iqbal/sticky-header
 */

const $stickyHeader = $('.header-main', context);

$stickyHeader.once('sticky-header').each((index, el) => {
  const $this = $(el);
  const $body = $('body');
  const $blockSection = $('.cpl-page-header');

  if (
    !$body.hasClass('adminimal-admin-toolbar') &&
    $blockSection.hasClass('cpl-header-sticky')
  ) {
    $this.stickMe({
      shadow: true,
      shadowOpacity: 0.3,
      topOffset: 600,
      triggerAtCenter: false,
    });

    $this.on('sticking', () => $body.addClass('has-sticky-header'));
    $this.on('top-reached', () => $body.removeClass('has-sticky-header'));
  }
});
